/* global SideDrawer */

const COMPACT_REVIEW_CONSENT_STYLE_ID = 'bh-cart-drawer-compact-review-consent';
const COMPACT_REVIEW_CONSENT_MEDIA = '(max-width: 749px)';

function ensureCompactReviewConsentStyles() {
  if (document.getElementById(COMPACT_REVIEW_CONSENT_STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = COMPACT_REVIEW_CONSENT_STYLE_ID;
  style.textContent = `
    @media ${COMPACT_REVIEW_CONSENT_MEDIA} {
      cart-drawer.js-cart-drawer .cart-drawer__footer {
        padding-top: 12px;
        padding-bottom: max(12px, env(safe-area-inset-bottom));
      }

      cart-drawer.js-cart-drawer .checkout-buttons {
        padding-top: 4px !important;
      }

      cart-drawer.js-cart-drawer .review-consent {
        margin: 0 0 8px !important;
        padding: 8px 0 0 !important;
        border-top: 1px solid rgb(var(--text-color) / var(--divider-opacity));
        border-radius: 0;
        background: transparent;
      }

      cart-drawer.js-cart-drawer .review-consent__row {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        min-width: 0;
      }

      cart-drawer.js-cart-drawer .review-consent__checkbox {
        flex: 0 0 18px;
        width: 18px;
        height: 18px;
        min-width: 18px;
        margin: 1px 0 0;
      }

      cart-drawer.js-cart-drawer .review-consent__row label,
      cart-drawer.js-cart-drawer .review-consent__text,
      cart-drawer.js-cart-drawer .review-consent__copy {
        min-width: 0;
      }

      cart-drawer.js-cart-drawer .review-consent__headline {
        display: block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        line-height: 1.25;
        font-weight: 600;
      }

      cart-drawer.js-cart-drawer .review-consent__details {
        margin: 2px 0 0 26px;
        font-size: 11px;
        line-height: 1.35;
      }

      cart-drawer.js-cart-drawer .review-consent__details summary {
        display: inline-flex;
        align-items: center;
        min-height: 22px;
        padding: 0;
        color: rgb(var(--text-color) / .72);
        font-size: 11px;
        line-height: 1.3;
        cursor: pointer;
      }

      cart-drawer.js-cart-drawer .review-consent__details summary::-webkit-details-marker {
        display: none;
      }

      cart-drawer.js-cart-drawer .review-consent__details summary::after {
        content: "";
        width: .45em;
        height: .45em;
        margin-left: 5px;
        border-right: 1px solid currentColor;
        border-bottom: 1px solid currentColor;
        transform: rotate(45deg) translateY(-1px);
      }

      cart-drawer.js-cart-drawer .review-consent__details[open] summary::after {
        transform: rotate(225deg) translateY(-1px);
      }

      cart-drawer.js-cart-drawer .review-consent__details > :not(summary) {
        margin-top: 4px;
        font-size: 11px;
        line-height: 1.35;
      }

      cart-drawer.js-cart-drawer .review-consent__status {
        margin: 3px 0 0 26px;
        font-size: 11px;
        line-height: 1.3;
      }
    }

    @media (max-width: 340px) {
      cart-drawer.js-cart-drawer .review-consent__headline {
        font-size: 11.5px;
      }
    }
  `;
  document.head.appendChild(style);
}

function compactReviewConsentDetails(root) {
  const isCompact = window.matchMedia(COMPACT_REVIEW_CONSENT_MEDIA).matches;

  root.querySelectorAll('.review-consent__details summary').forEach((summary) => {
    if (!summary.dataset.bhOriginalDetailsText) {
      summary.dataset.bhOriginalDetailsText = summary.textContent.trim().replace(/\s+/g, ' ');
    }

    const originalText = summary.dataset.bhOriginalDetailsText;
    if (isCompact) {
      if (originalText && originalText !== 'Details') {
        summary.setAttribute('aria-label', `${originalText}: Details zum 10 Prozent Gutschein`);
        summary.title = originalText;
      }
      summary.textContent = 'Details';
    } else {
      summary.textContent = originalText || 'Details';
      summary.removeAttribute('aria-label');
      summary.removeAttribute('title');
    }
  });
}

class CartDrawer extends SideDrawer {
  connectedCallback() {
    ensureCompactReviewConsentStyles();
    compactReviewConsentDetails(this);
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      compactReviewConsentDetails(this);
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      compactReviewConsentDetails(this);
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
